define([
    'backbone',
    'modules/common/orders/models/base',
    'appcontext',
    'modules/common/planning/collections/plannedmetric'
], (Backbone, OrderBaseModel, appContext, OrderMetricCollection) => {

    OrderMetricCollection = OrderMetricCollection.default;

    const AgeModel = Backbone.Model.extend({
        initialize (age) {
            if (age && !(age.from || age.to)) {
                const ages = this.parse(age);
                this.attributes.from = ages.from;
                this.attributes.to = ages.to;
            }
        },
        parse (age) {

            /*
             * Ages come from backend as "FROMx_TOy", where x is lower age bound and y is upper bound,
             * or if there is no lower or upper bound, ages come as "FROMx" or "TOy"
             */
            let ages;
            const includeFrom = age.search('FROM') !== -1;
            const includeTo = age.search('TO') !== -1;
            if (includeFrom && includeTo) {
                age = age.replace('FROM', '');
                age = age.replace('TO', '');
                ages = age.split('_');
                return {
                    from: parseInt(ages[0]),
                    to: parseInt(ages[1])
                };
            } else if (includeFrom) {
                ages = age.replace('FROM', '');
                return {
                    from: parseInt(ages)
                };
            } else if (includeTo) {
                ages = age.replace('TO', '');
                return {
                    to: parseInt(ages)
                };
            }
        },
        toJSON () {

            // Ages are kept as "FROMx_TOy"
            if (!this.attributes) {
                return;
            }
            const ages = [];
            if (this.attributes.from) {
                ages.push('FROM{0}'.format(this.attributes.from));
            }
            if (this.attributes.to) {
                ages.push('TO{0}'.format(this.attributes.to));
            }
            return ages.join('_');
        }

    });

    return OrderBaseModel.extend({
        urlRoot: '/orders',

        nested: {
            metrics: OrderMetricCollection,
            age_ranges: Backbone.Collection.extend({
                model: AgeModel,
                initialize () {
                    return Backbone.Model.prototype.initialize.apply(this, arguments);
                }
            })
        },

        defaults () {
            let defaults = _.extend(OrderBaseModel.prototype.defaults.apply(this, arguments), {
                name: null,
                project_id: null,
                created_at: null,
                channel_id: null,
                regions: [0],
                genders: [],
                metrics: [],
                age_ranges: [],
                excluded_categories: [],
                comment: '',
                advertiser_id: null,
                impressions_planned: 0,
                by_price: false,
                cost_type: null,

                // Blondinka
                formats: [],
                pay_type: 'POST'
            });

            if (appContext.account() && appContext.has_component('RORE')) {

                defaults = _.extend(defaults, {

                    // Override common properties
                    regions: [225],

                    // rore
                    account_id: null,
                    project_id: null,
                    tech_name: null,
                    unit_price: 0,
                    units: 0,
                    rotation_type_id: null,
                    buying_model: null,
                    discount: 0,
                    agency_commission: 0,
                    agency_commission_fix: 0,
                    freq_units: 'NO',
                    freq_views_units: 'NO',
                    freq_number: 0,
                    freq_units_number: 0,
                    coefficients: [],
                    site_type_ids: [],
                    site_platform_ids: [],
                    place_context_ids: [],
                    format_types: [],
                    places_formats: '',
                    planning_type: 'UNITS',

                    budget_split: 'SOFT',

                    status: 'DRAFT',
                    creatives_status: 'NO',
                    billing_status: 'NO',
                    counter_status: 'NO',
                    project_1c_status: 'NO',
                    trading_status: 'MODERATION',
                    client_status: 'NOT_SENT',

                    tracker_buying_model: null,
                    tracker_unit_price: 0,
                    tracker_units: 0,
                    tracker_ad_backup: 100,
                    tracking_channel_id: null,
                    ac_on_tracking: false,

                    tech_cost_id: null,
                    tech_cost_external_type: '',
                    tech_cost_external_value: 0,
                    tech_cost_internal_value: 0,
                    started: false,
                    dates_changed: false,
                    planned_changed: false,
                    recalculate_periods: false,
                    end_date_changed: false,
                    end_date_current_period: false,

                    autobinding_placements: false
                });
            }

            return defaults;
        },

        initialize () {
            OrderBaseModel.prototype.initialize.apply(this, arguments);
        },

        hasAudienceParameters () {
            return this.get('genders').length || this.get('age_ranges').length ||
                this.get('excluded_categories').length;
        },

        unsetAudienceParameters () {
            this.set({genders: [], age_ranges: [], excluded_categories: []});
        },

        isFineTuned () {
            return this.get('is_fine_tuned');
        },

        needRecalculation () {
            if (this.isNew()) {
                return false;
            }
            return this.get('planned_changed') || !this.get('started') && this.get('dates_changed');
        },

        recalculationOptionsSetted () {
            return Boolean(this.get('recalculate_periods'));
        }
    });
});
